module.exports = __webpack_public_path__ + "static/media/pending.2b87728c.png";